import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table-title"
}
const _hoisted_2 = { class: "data-table" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "label"
}
const _hoisted_6 = { class: "value" }

import { computed, onMounted, ref, watch } from "vue";
import { styleZoom } from "@/common/utils/style";
import { fileAvatarFileShow } from "@/common/api/rest/file/avatar";


export default /*@__PURE__*/_defineComponent({
  __name: 'block-data',
  props: {
    block: {},
    selectedBlock: {},
    zoom: {}
  },
  emits: ["block:update"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const images = ref<{ [key: string]: string }>({});

const columns = computed(() =>
  props.block.content?.columns?.filter((col: any) => !!col.visible),
);

const fields = computed(() =>
  props.block.content?.fields?.filter((f: any) => !!f.visible),
);

const trows = computed(() => {
  const rowsData = props.block.content?.rows || [];

  return rowsData.map((rowFields: any[]) => {
    // Para cada linha, percorremos as colunas visíveis
    return columns.value.map((col: any) => {
      // Encontramos o campo dentro da linha que pertence a esta coluna
      const items = rowFields
        .filter((f: any) => f.col === col.id && f.visible)
        .map((f: any) => {
          return {
            ...f,
            label: fields.value.find((field: any) => field.id === f.field)
              ?.label,
          };
        });

      return {
        columnId: col.id,
        fields: items || [], // Retorna o campo ou null se não houver dados para essa célula
      };
    });
  });
});

/**
 * Retorna a URL final para exibir uma imagem.
 * - Se o value já for uma data URL, usa direto (o editor já resolveu).
 * - Se ainda for um ID, busca no cache `images`.
 */
function resolveImageSrc(value: any): string {
  if (!value) return "";

  if (typeof value === "string") {
    if (value.startsWith("data:")) return value;
    return images.value[value] ?? "";
  }

  if (value.file) {
    return `data:${value.mime_type ?? "image/png"};base64,${value.file}`;
  }

  if (value.base64) return value.base64;

  return "";
}

async function getImages() {
  const newImages = Object.keys(images.value).filter((id) => !images.value[id]);

  if (newImages.length === 0) return;

  const promises = newImages.map((id) =>
    fileAvatarFileShow(props.block.account_id, id),
  );

  await Promise.all(promises).then((response) => {
    response.forEach((res, index) => {
      if (res?.success && res.data?.base64) {
        const id = newImages[index];
        images.value[id] = res.data.base64;
      }
    });
  });
}

async function initialize() {
  const newImages = props.block.content.rows
    .flatMap((row: any[]) => row)
    .filter((item: any) => item.value && item.is_image)
    .reduce(
      (acc: any, item: any) => {
        const value = item.value;

        // Se o valor já é uma data URL (editor já resolveu), usa direto.
        if (typeof value === "string" && value.startsWith("data:")) {
          acc[value] = value;
          return acc;
        }

        // Caso ainda seja um ID, agenda o fetch (se ainda não temos).
        if (typeof value === "string" && !images.value[value]) {
          acc[value] = "";
        }

        return acc;
      },
      {} as { [key: string]: string },
    );
  images.value = { ...newImages, ...images.value };
  await getImages();
}

watch(
  () => props.block,
  async () => {
    if (!props.block) {
      return;
    }

    await initialize();
  },
  { immediate: true },
);

onMounted(async () => {
  if (!props.block) {
    return;
  }

  await initialize();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["table-block", {
      selected: !!__props.selectedBlock,
    }]),
    style: _normalizeStyle(_unref(styleZoom)(__props.block.style, __props.zoom))
  }, [
    (__props.block.content?.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.block.content?.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trows.value, (rowCells, rowIndex) => {
          return (_openBlock(), _createElementBlock("tr", { key: rowIndex }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rowCells, (cell) => {
              return (_openBlock(), _createElementBlock("td", {
                key: cell.columnId
              }, [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cell.fields, (field) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: field.id,
                      class: _normalizeClass(["item", {
                        is_imagem: field.is_image,
                      }])
                    }, [
                      (field.is_image)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (resolveImageSrc(field.value))
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: resolveImageSrc(field.value)
                                }, null, 8, _hoisted_4))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (field.label)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(field.label) + ":", 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_6, [
                              (field.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(field.value), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(" - ")
                                  ], 64))
                            ])
                          ], 64))
                    ], 2))
                  }), 128))
                ])
              ]))
            }), 128))
          ]))
        }), 128))
      ])
    ])
  ], 6))
}
}

})